import { Injectable } from '@angular/core';
// import { RemoteService } from './../remote.service';
import { IUrlOptions } from './../../models/rest.caller.model';
import { LoggingConstants } from './../../constants/logging-constant';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { UIStorageService } from './../storage.service';
import { AppStartupService } from './../app-startup';
import { DomStorageFallbackService } from './../DomStorageFallback.service';
import { LoggingService } from './logging.service';
import { AppUtility } from '../../utils/utility';

// @dynamic
@Injectable()
export class LoggingStartupConfigService {
    // Declaration of different logging level hierarchy as per severity.
    public static logHierarchyOrderMap = new Map();
    // Application allowed log level for different log use cases like UxError,ExUsage etc.
    public static appLogLevelConfig: {};
    // Default log level for different level of tracing.
    public static appLogLevelConfig_default: object = {
        'UxPageUsage': 'INFO',
        'UxUsage': 'OFF',
        'UxDebug': 'OFF',
        'UxError': 'ERROR',
        'UxScreenCapture': 'INFO',
        'UxRenderEvent': 'INFO'
    };

    // Severity level hierarchy arrays.

    /* istanbul ignore next */
    private logFATAL_hierarchy = ['FATAL'];
    private logERROR_hierarchy = ['FATAL', 'ERROR'];
    private logWARN_hierarchy = ['FATAL', 'ERROR', 'WARN'];
    private logINFO_hierarchy = ['FATAL', 'ERROR', 'WARN', 'INFO'];
    private logDEBUG_hierarchy = ['FATAL', 'ERROR', 'WARN', 'INFO', 'DEBUG'];
    private logOFF_hierarchy = [];
    private loggingConfigKey = 'isLoggingConfigLoaded';
    private globalSessionId: string = '';

    /* istanbul ignore next */
    constructor(private appUtility: AppUtility, private http: HttpClient, private domStorageFB: DomStorageFallbackService) {
        LoggingStartupConfigService.logHierarchyOrderMap.set('FATAL', this.logFATAL_hierarchy);
        LoggingStartupConfigService.logHierarchyOrderMap.set('ERROR', this.logERROR_hierarchy);
        LoggingStartupConfigService.logHierarchyOrderMap.set('WARN', this.logWARN_hierarchy);
        LoggingStartupConfigService.logHierarchyOrderMap.set('INFO', this.logINFO_hierarchy);
        LoggingStartupConfigService.logHierarchyOrderMap.set('DEBUG', this.logDEBUG_hierarchy);
        LoggingStartupConfigService.logHierarchyOrderMap.set('OFF', this.logOFF_hierarchy);
        // this.initLoggingConfig();
    }

    /**
     * init function for loading Logging level config from server.
     */

    /* istanbul ignore next */
    public initLoggingConfig() {

        if (LoggingService.uConsole) {
            console.log('In LoggingStartupConfigService.initLoggingConfig():: Starting loading log configuration from server');
        }
        if (this.checkIsAlreadyProcessed()) {
            return;
        }

        // Added validation for checking channelRequestData in alightRequestHeader start here
        let isChannelRequestData = false;
        const alightRequestHeaderString = this.domStorageFB.getItem('alightRequestHeader');
        if (LoggingService.uConsole) {
            console.log('alightRequestHeader in log configuration', alightRequestHeaderString);
        }
        if (alightRequestHeaderString) {
            isChannelRequestData = alightRequestHeaderString.indexOf('channelRequestData') !== -1;
            if (LoggingService.uConsole) {
                console.log('isChannelRequestData in log configuration', isChannelRequestData);
            }
        }
        // validation for checking channelRequestData in alightRequestHeader ends here
        let urlOptions: IUrlOptions = {
            restOfUrl: '',
            endPoint: LoggingConstants.LOG_LEVEL_CONFIG_URL, isSecure: true, contentType: 'application/json'
        };
        let _headers = new HttpHeaders();
        try {
            /* if (this.domStorageFB.isValidToken(this.domStorageFB.getTokenValue('alightSecureSessionToken', '', true))) {
                _headers = _headers.append('alightSecureSessionToken', this.domStorageFB.getItem('alightSecureSessionToken', '', true));
            } else {
                _headers = _headers.append('alightPersonSessionToken', this.domStorageFB.getItem('alightSecureSessionToken', '', true));
            } */
            if (this.domStorageFB.isValidToken(this.domStorageFB.getTokenValue('alightPersonSessionToken', '', true))) {
                _headers =  _headers.append('alightPersonSessionToken', this.domStorageFB.getTokenValue('alightPersonSessionToken', '', true));
            } else if (this.domStorageFB.isValidToken(this.domStorageFB.getTokenValue('alightSecureSessionToken', '', true))) {
                _headers = _headers.append('alightSecureSessionToken', this.domStorageFB.getTokenValue('alightSecureSessionToken', '', true));
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('initLoggingConfig:: Error while setting alightSecureSessionToken header ', error);
            }
        }
        try {
            // Add UxUniquePageId, PageName and DeviceType to channelRequestData
            this.appUtility.updateChannelRequestData({
                'uxPageRequestId': this.domStorageFB.getItem('uniquePageId', '', true),
                'pageName': this.appUtility.getPageNameFromURL(),
                'deviceType': this.domStorageFB.getItem('upointDeviceType', '', true),
                'sessionCreatedTimestamp': this.domStorageFB.getItem('sessionCreatedTimestamp', 'sessionStorage', true),
                'widgetName': null
            });

            let tempValue = JSON.parse(this.domStorageFB.getItem('alightRequestHeader'));
            // let updatedTempValue = this.storageService.addAttributeToJsonObject('consumerReferenceId', this.storageService.uuid(), tempValue);
            _headers = _headers.append('alightRequestHeader', JSON.stringify(tempValue));
            _headers = _headers.append('Content-Type', urlOptions.contentType);
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('initLoggingConfig:: Error while setting alightRequestHeader header ', error);
            }
        }
        _headers = this.constructHeader(urlOptions, _headers);

        let options = { headers: _headers };
        let endPointUrl = this.constructUrl(urlOptions);

        // tslint:disable-next-line:max-line-length
        if (endPointUrl && (this.domStorageFB.isValidToken(this.domStorageFB.getTokenValue('alightPersonSessionToken', '', true)) || this.domStorageFB.isValidToken(this.domStorageFB.getTokenValue('alightSecureSessionToken', '', true))) && (isChannelRequestData !== false)) {
            this.http.get(endPointUrl, options)
                .subscribe(res => {
                    this.domStorageFB.setItem(this.loggingConfigKey, 'true', 'localStorage');
                    LoggingStartupConfigService.appLogLevelConfig = res;
                }, err => {
                });
        }
    }

    /**
     * Function for loading Log config level of different tracing.
     */

    /* istanbul ignore next */
    public getLoggingConfigLevel() {
        try {
            if (LoggingStartupConfigService.appLogLevelConfig) {
                return LoggingStartupConfigService.appLogLevelConfig;
            } else {
                return LoggingStartupConfigService.appLogLevelConfig_default;
            }
        } catch (error) {
            return LoggingStartupConfigService.appLogLevelConfig_default;
        }
    }


    /**
    * Contrusting Headers for logging request.
    * @param urlOptions
    * @param header
    */

    /* istanbul ignore next */
    private constructHeader(urlOptions: IUrlOptions, header: HttpHeaders): HttpHeaders {
        const cHeader: any[] = urlOptions.customHeader;
        for (const aHeaderItem in cHeader) {
            if (aHeaderItem) {
                header.append(cHeader[aHeaderItem].key, cHeader[aHeaderItem].value);
            }
        }
        return header;
    }

    /**
     * Function for creating Http url endpoint based on session storage value.
     * @param urlOptions
     */

    /* istanbul ignore next */
    private constructUrl(urlOptions: IUrlOptions): string {
        // if (this.appStartup.gateWayURL() == null) {
        //     return null;
        // }
        let GatewayURL = '';
        try {
            // tslint:disable-next-line:max-line-length
            if ((this.domStorageFB.getItem('enableDynamicURL') === null || this.domStorageFB.getItem('enableDynamicURL') === 'null') || (this.domStorageFB.getItem('enableDynamicURL') === false || this.domStorageFB.getItem('enableDynamicURL') === 'false')) {
                GatewayURL = this.domStorageFB.getItem('gatewayUrl');
            } else {
                let newApiUrl = this.appUtility.getUpointNextUrl();
                newApiUrl = newApiUrl + '/alightapi/api/';
                GatewayURL = newApiUrl;
            }
        } catch (error) {
            // No Logging possible since the constructor failed to get endpoints
            GatewayURL = null;
        }
        return GatewayURL + urlOptions.endPoint + urlOptions.restOfUrl;
    }

    /**
     * Function for checking that Is already Api called for getting configuration.
     */
    /* istanbul ignore next */
    private checkIsAlreadyProcessed(): boolean {
        if (this.domStorageFB.getItem(this.loggingConfigKey, 'localStorage')) {
            return true;
        } else {
            return false;
        }
    }


    /**
     * Function for getting GlobalsessionId from alightrequestheader.
     * This globalsession value will be sent with logging details to server.
     */
    /* istanbul ignore next */
    public getGlobalSessionID() {
        try {
            if (this.globalSessionId) {
                return this.globalSessionId;
            } else {
                let alightRequestHeaderValue = JSON.parse(this.domStorageFB.getItem('alightRequestHeader', 'sessionStorage'));
                if (alightRequestHeaderValue) {
                    let channelReqData = alightRequestHeaderValue.channelRequestData;
                    let dataValue = channelReqData.split('::');
                    let gblsDataIndexValue = dataValue.indexOf('gblsId');
                    if (gblsDataIndexValue !== -1) {
                        this.globalSessionId = dataValue[gblsDataIndexValue + 1];
                    }
                    return this.globalSessionId;
                }
            }
        } catch (error) {
            if (LoggingService.uConsole) {
                console.log('In LoggingStartupConfigService.getGlobalSessionID() error occurred ', error);
            }
            return this.globalSessionId;
        }
    }

}
